import getDashBoardStore from "../../stores/dashboard-store";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import AdminSalary from "./AdminSalary";
import SideBarMenu from "./SideBarMenu";
import UserInfo from "./UserInfo";
import KhattabatCapacity from "./KhattabatCapacity";

const SideBar = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;

  const isAlert = getDashBoardStore().getIsAlert.get();
  return (
    <ET3Div
      isScrollable={true}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={1110}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.red}
      style={{
        minHeight: 1110 * unitY
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={true}
        isExtendable={false}
        withShadow={false}
        width={300}
        height={1110}
        fDirection="column"
        alignItems="flex-end"
        justifyContent="flex-start"
        color={isAlert ? colors.all.red : colors.all.darkSlateGray}
        style={{
          position: "relative",
          overflowX: "hidden"
        }}
        onClick={() => {}}
      >
        <Et3Margin top={0} left={0} right={0} bottom={40} />
        <UserInfo />
        <Et3Margin top={0} left={0} right={0} bottom={30} />
        <KhattabatCapacity />
        <AdminSalary />
        <SideBarMenu isAlert={isAlert} />
      </ET3Div>
    </ET3Div>
  );
});
export default SideBar;
